module.exports = __webpack_public_path__ + "static/media/nachos.42165938.jpg";